import { render } from "./CadastroDocumentosSinistrosView.vue?vue&type=template&id=0a6380a8"
import script from "./CadastroDocumentosSinistrosView.vue?vue&type=script&lang=js"
export * from "./CadastroDocumentosSinistrosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__